import { render, staticRenderFns } from "./IndicationCard.vue?vue&type=template&id=01917136&scoped=true&lang=pug"
import script from "./IndicationCard.vue?vue&type=script&lang=js"
export * from "./IndicationCard.vue?vue&type=script&lang=js"
import style0 from "./IndicationCard.vue?vue&type=style&index=0&id=01917136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01917136",
  null
  
)

export default component.exports